import { css } from '@emotion/react'
import { Color } from '@opallabs/gem'

export const container = css({
  position: 'absolute',
  top: 50,
  zIndex: 3,
})

export const infoContainer = css({
  alignItems: 'center',
  backgroundColor: '#f4f7f9',
  color: Color.light.Text.Gray,
  display: 'flex',
  flexFlow: 'column wrap',
  height: 700,
  justifyContent: 'center',
  width: 900,
})

export const iframe = css({
  border: 0,
})

export const headline = css({
  color: Color.light.Text.Default,
  fontSize: 32,
  marginTop: 20,
})

export const text = css({
  fontSize: 14,
  fontWeight: 600,
  lineHeight: '20px',
  margin: '10px 0px 20px 0px',
  textAlign: 'center',
  width: 400,
})

export const contactUs = css({
  backgroundColor: 'inherit',
  border: 'none',
  color: '#276CE0',
  cursor: 'pointer',
  '&:hover': {
    color: '#14418d',
  },
})

export const servicesWrapper = css({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  listStyleType: 'none',
  width: 400,
})

export const service = css({
  borderBottom: `1px solid ${Color.light.Surface.N300}`,
  fontSize: 14,
  fontWeight: 500,
  padding: 10,
  '&:nth-child(1), &:nth-child(2)': {
    borderTop: `1px solid ${Color.light.Surface.N300}`,
  },
  '&:nth-child(odd)': {
    borderRight: `1px solid ${Color.light.Surface.N300}`,
  },
})
